import { createSelector } from '@reduxjs/toolkit';
import { fetchUser } from './userActionCreators';

const TWO_MINUTES = 120000;

const shouldRefreshUser = createSelector(
    [(state) => state.lifecycle.appTime - state.user.lastFetch > TWO_MINUTES, (state) => state.user.shouldUpdate],
    (timeToFetch, shouldUpdate) => timeToFetch || shouldUpdate
);

export const refreshUser = createSelector([shouldRefreshUser], (should) => {
    if (should) {
        return fetchUser();
    }
});
